import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, defineMessages, FormattedNumber } from 'react-intl';
import { createSelector } from 'reselect';
import Global from '../../../../store/global-selectors';
import { Pill } from 'ui-components/components/pill';
import { ActionableFilterPill } from '../../index';

import style from '../../actionable-filter-pill.module.less';

const messages = defineMessages({
  filterTitle: {
    description: 'filterOptions.tag',
    defaultMessage: 'Tag',
    id: '15Wjuc',
  },
  multipleSelected: {
    defaultMessage: '{selectedTagCount} of {totalTagCount} selected',
    id: 'd4y+mH',
    description: 'the amount of selected tags out of total tags',
  },
});

const UnselectedTag = <FormattedMessage {...messages.filterTitle} />;

export const getDisplayContent = (appliedFilters, tags) => {
  if (appliedFilters.length === 0) {
    return UnselectedTag;
  }

  if (appliedFilters.length === 1) {
    const [filter] = appliedFilters;
    const { criterionMeta, criterionArgumentValue: tagId } = filter;
    if (!tagId) {
      return UnselectedTag;
    }
    const tag = criterionMeta || tags[tagId];
    return (
      !!tag && (
        <div className={style['single-pill-wrapper']}>
          <Pill className={style['tag-pill']} color={tag.hexColor} />
          <div>{tag.name}</div>
        </div>
      )
    );
  }
  return (
    <FormattedMessage
      {...messages.multipleSelected}
      values={{
        selectedTagCount: <FormattedNumber value={appliedFilters.length} />,
        totalTagCount: <FormattedNumber value={Object.keys(tags).length} />,
      }}
    />
  );
};

const tagFiltersAreValidForGrid = (appliedFilters) =>
  appliedFilters.every((filter) => {
    const { criterionArgumentValue } = filter;
    return !!criterionArgumentValue;
  });

const displayContentSelector = createSelector(
  (appliedFilters) => appliedFilters,
  (_, tags) => tags,
  getDisplayContent,
);

const mapStateToProps = (state, ownProps) => {
  const appliedFilters = Global.selectOrdersFilteringActiveFilterViewFiltersById(state, {
    filterById: ownProps.filterById,
  });
  const tags = Global.selectSellerTagsAsDictionary(state);
  const isSelected = !!appliedFilters.length && tagFiltersAreValidForGrid(appliedFilters);

  const displayContent = displayContentSelector(appliedFilters, tags);
  return {
    isSelected,
    displayContent,
  };
};

export const Tag = connect(mapStateToProps, null, null, { forwardRef: true })(ActionableFilterPill);
